var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 12,
    height: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21,0H3C1.346,0,0,1.346,0,3v21h24V3c0-1.654-1.346-3-3-3Zm1,22H2V3c0-.551.448-1,1-1h18c.552,0,1,.449,1,1v19Zm-5-17h2v4c0,1.103-.897,2-2,2h-4v-2h2.997c-.928-1.234-2.398-2-3.997-2-2.414,0-4.434,1.721-4.899,4h-2.021c.488-3.387,3.401-6,6.92-6,1.924,0,3.709.8,5,2.12v-2.12Zm-.101,8h2.021c-.488,3.387-3.401,6-6.92,6-1.924,0-3.709-.8-5-2.12v2.12h-2v-4c0-1.103.897-2,2-2h4v2h-2.997c.928,1.234,2.398,2,3.997,2,2.414,0,4.434-1.721,4.899-4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/Update.5543dc5eada109f2aafa307e1a1802af.svg";
export { ForwardRef as ReactComponent };